module.exports = __webpack_public_path__ + "static/gcp-b392cd7b849517acbbaba6352ec600d8.png";